/*eslint-disable*/
import {
  Card,
  FormControl,
  Typography,
  CircularProgress
} from "@material-ui/core";
import Button from "@material-ui/core/Button";
import sqLogo from "assets/img/sure_quote_website_logo.png";
import background from "assets/img/web-background2.jpg";
import FormInput from "components/Wrappers/materialUIWrappers/components/FormInput";
import FormInputPassword from "components/Wrappers/materialUIWrappers/components/FormInputPassword";
import React from "react";
import { Field, reduxForm } from "redux-form";
import { SetForgotPassword } from "queries/portal/mutations";
import { successWarning, showSnack } from "reducers/NotificationReducer";
import store from "store";
import { graphql } from "react-apollo";

const required = value => (value ? undefined : "Required");
const email = value => {
  let mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;

  return value.match(mailformat) ? undefined : "Not a Valid Email Addres";
};

class ForgotPassword extends React.Component {
  state = {
    checkValidation: false,
    loading: false
  };

  submit = () => {
    if (
      store.getState().form.forgotpassword.values["email"] !==
      store.getState().form.forgotpassword.values["email_confirm"]
    ) {
      store.dispatch(
        showSnack({
          message: "Emails do not match",
          color: "danger"
        })
      );
    } else if (store.getState().form.forgotpassword.syncErrors) {
      this.setState({ checkValidation: true });
      store.dispatch(
        showSnack({
          message: "Invalid data.",
          color: "danger"
        })
      );
    } else {
      this.setState({ loading: true });

      let data = store.getState().form.forgotpassword.values;

      var input = {
        email: data.email
      };

      this.props
        .mutate({
          variables: {
            input
          }
        })
        .then(() => {
          this.setState({ loading: false });
          store.dispatch(
            successWarning({
              open: true,
              title: "Password Reset email has been sent to you",
              onConfirm: () =>
                this.props.history.push({
                  pathname: "/app/portal/login"
                })
            })
          );
        })
        .catch(error => {
          this.setState({ loading: false });
          store.dispatch(
            showSnack({
              message: "There was an error : " + error,
              color: "danger"
            })
          );
        });
    }
  };

  render() {
    return (
      <div
        className={"loginContainer"}
        style={{ backgroundImage: "url(" + background + ")" }}
      >
        <Card className={"loginCard"}>
          <div className={"loginBox"}>
            <div style={{ margin: "40px auto 40px auto" }}>
              <img className="sqLogo" src={sqLogo} alt="sqLogo" />
            </div>
            <Typography
              variant="title"
              className="centerCell"
              style={{ marginBottom: "15px" }}
            >
              Forgot Password
            </Typography>
            <Typography variant="body1" className="centerCell">
              We will send you an email containing a link to reset your password
            </Typography>
            <FormControl fullWidth>
              <Field
                component={FormInput}
                isrequired={true}
                validate={[required, email]}
                checkValidation={this.state.checkValidation}
                name="email"
                label="Email *"
              />
            </FormControl>

            <br />

            <FormControl fullWidth>
              <Field
                component={FormInput}
                isrequired={true}
                validate={[required, email]}
                checkValidation={this.state.checkValidation}
                name="email_confirm"
                label="Confirm Email *"
                handleKeyPress={this.passwordKeyPressed}
              />
            </FormControl>

            <Button
              variant="outlined"
              className="outlinedButton"
              color="primary"
              style={{ margin: "auto", marginTop: "8vh", marginBottom: "15vh" }}
              onClick={() => (!this.state.loading ? this.submit() : {})}
              fullWidth
            >
              {this.state.loading ? <CircularProgress size={20} /> : "SUBMIT"}
            </Button>
          </div>
        </Card>
      </div>
    );
  }
}

ForgotPassword = reduxForm({
  form: "forgotpassword",
  destroyOnUnmount: true
})(ForgotPassword);

ForgotPassword = graphql(SetForgotPassword)(ForgotPassword);

export default ForgotPassword;



// WEBPACK FOOTER //
// ./src/views/Portal/ForgotPassword.jsx